module.exports = __webpack_public_path__ + "assets/img/5.0ac4b69f.jpg";